<template>
  <div class="page-index">
    <Header background-image="images/hero.jpg">
      <h2 class="header__title">{{ cardTitle }}</h2>

      <h3 class="header__subtitle">
        {{ cardText }}
      </h3>

      <TCard class="header__card">
        <div class="card__form">
          <PostalFormStep :progress-value="0" />
        </div>
      </TCard>

      <span class="header__subtext">
        {{ cardSubtext }}
      </span>
    </Header>

    <!-- PD-10913 start — below-the-fold swap -->
    <HowItWorksSection v-if="isRedesignVariant" />
    <HomeBlock v-else id="usps">
      <Usps :usps="usps" />
    </HomeBlock>
    <!-- PD-10913 end -->
  </div>
</template>

<script>
import AbstractHomePage from 'chimera/all/components/page/AbstractHomePage'
import HomeBlock from 'chimera/all/components/HomeBlock'
import Usps from 'chimera/all/themes/blueflow/components/Usps'
import Header from 'chimera/all/themes/blueflow/components/layout/Header'
import { useExperiments } from 'chimera/all/composables/useExperiments'
import { SKALE_0014_REDESIGNED_FUNNEL } from 'chimera/all/constants/experiments'
import PostalFormStep from '~/components/form/steps/postal/PostalFormStep.vue'
import HowItWorksSection from '~/components/page/HowItWorksSection.PD-10913'

export default {
  components: {
    Header,
    HomeBlock,
    HowItWorksSection,
    PostalFormStep,
    Usps,
  },

  extends: AbstractHomePage,

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Makelaarwijzer.nl',
      headTitleTemplate: '%s',
      headDescription:
        'Vul je postcode in en vergelijk geheel gratis 6 offertes van top makelaars uit jouw regio. ✓Dé beste prijs voor jouw makelaar ✓Bespaar tot 40% ✓100% Gratis!',
      path: '/',
      usps: [
        {
          title: 'Beantwoord een paar vragen',
          text: 'Je vertelt ons wat je zoekt, hierdoor kunnen wij de juiste makelaar uit jouw regio aan jou koppelen.',
          logo: require('chimera/all/themes/blueflow/images/usps/pencil.svg'),
        },
        {
          title: 'Ontvang gratis offertes',
          text: 'Je ontvangt maximaal zes offertes van makelaars die aan je behoeften voldoen. Hiermee bespaar je tot 40%!',
          logo: require('chimera/all/themes/blueflow/images/usps/offer.svg'),
        },
        {
          title: 'Kies de juiste makelaar',
          text: 'Wij hebben onze makelaars al gecheckt, je hoeft alleen maar de offertes te vergelijken en te kiezen.',
          logo: require('chimera/all/themes/blueflow/images/usps/user.svg'),
        },
      ],
      cardTitle: 'Vind dé makelaar in jouw regio',
      cardText: 'Vergelijk offertes voordat je beslist en bespaar tot 40%!',
      cardSubtext: 'Vergelijk 6 makelaars in jouw regio',
      isRedesignVariant: false,
    }
  },

  /**
   * PD-10913: expose on load. Above the fold is identical in both arms, so the
   * below-the-fold swap lands off-screen and the postcode card never remounts.
   */
  async created() {
    if (!process.client) return

    const { getExperiment, isVariant } = useExperiments(this.$store)
    const experiment = await getExperiment(SKALE_0014_REDESIGNED_FUNNEL)

    this.isRedesignVariant = isVariant(experiment, 1)
  },
}
</script>
